import { useQuery } from "@apollo/client";
import { Spinner } from "@src/components/elements";
import { NotFound } from "@src/pages/NotFound";
import { Page } from "@src/shared/pages";
import { gql } from "@src/__generated__";
import React from "react";
import { Navigate } from "react-router-dom";

const PAYMENTS_GATEKEEPER = gql(/* GraphQL */ `
  query PaymentsGatekeeper {
    currentCompany {
      paymentsEnabled
      paymentsOnboarded
    }
  }
`);

export function PaymentsGatekeeper({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data } = useQuery(PAYMENTS_GATEKEEPER);

  if (!data) {
    return <Spinner />;
  }

  if (!data.currentCompany.paymentsEnabled) {
    return <NotFound />;
  }

  if (!data.currentCompany.paymentsOnboarded) {
    return <Navigate to={Page.MANAGE_PAYMENTS_ONBOARDING} />;
  }

  return <>{children}</>;
}
